import { library } from '@fortawesome/fontawesome-svg-core'
import { fas }     from '@fortawesome/free-solid-svg-icons'

library.add(fas)

export const progress = (points) => {
  const done = points.filter(point => point.checked).length
  return { done, total: points.length, complete: points.length > 0 && done === points.length }
}

// The CSM decides: validated is the board's Tests field set to PASS, by hand.
export const isValidated = (issue) => issue.tests_state === 'pass'

export const TESTS_STATES = [
  { key: 'pending', label: 'En attente' },
  { key: 'tested',  label: 'À corriger' },
  { key: 'pass',    label: 'Validé' }
]

const BOARD_TONES = {
  GRAY:   'bg-slate-200 text-slate-800',
  BLUE:   'bg-blue-100 text-blue-800',
  GREEN:  'bg-emerald-100 text-emerald-800',
  YELLOW: 'bg-amber-100 text-amber-800',
  ORANGE: 'bg-orange-100 text-orange-800',
  RED:    'bg-rose-100 text-rose-800',
  PINK:   'bg-pink-100 text-pink-800',
  PURPLE: 'bg-purple-100 text-purple-800'
}

const BOARD_DOTS = {
  GRAY:   'border-slate-500 bg-slate-100',
  BLUE:   'border-blue-600 bg-blue-100',
  GREEN:  'border-emerald-600 bg-emerald-100',
  YELLOW: 'border-amber-500 bg-amber-100',
  ORANGE: 'border-orange-500 bg-orange-100',
  RED:    'border-rose-600 bg-rose-100',
  PINK:   'border-pink-500 bg-pink-100',
  PURPLE: 'border-purple-600 bg-purple-100'
}

export const boardTone = (color) => BOARD_TONES[color] || 'bg-white text-slate-900'
export const boardDot  = (color) => BOARD_DOTS[color] || 'border-slate-400 bg-white'

export const percent = ({ done, total }) => (total === 0 ? 0 : Math.round((done / total) * 100))

// Full class strings: brand-* and violet-* are not in the Tailwind safelist.
export const ENVIRONMENTS = {
  preview: {
    group: 'Preview',
    icon:  'flask',
    tile:  'bg-violet-50 text-violet-600',
    hint:  'Environnement dédié à cette demande'
  },
  staging: {
    group: 'Staging',
    icon:  'server',
    tile:  'bg-brand-50 text-brand-600',
    hint:  'Version livrée, à valider avant la mise en production'
  },
  none: {
    group: 'En préparation',
    icon:  'hourglass-half',
    tile:  'bg-slate-100 text-slate-500',
    hint:  'Le lien s’affiche ici dès que l’environnement est prêt'
  }
}

// Cards the team sets to "Tests - N / A": the developers verify them, outside the
// CSM team's queue.
export const TECHNICAL = {
  group: 'Suivi technique',
  icon:  'gear',
  label: 'Équipe technique',
  text:  'Cette demande est vérifiée par l’équipe technique.'
}

// Same tones as the tickets screen's status chips.
export const TICKET_TONES = {
  open:         'bg-amber-100 text-amber-800',
  in_progress:  'bg-blue-100 text-blue-800',
  in_evolution: 'bg-purple-100 text-purple-800',
  resolved:     'bg-emerald-100 text-emerald-800'
}

export const ticketTone = (status) => TICKET_TONES[status] || 'bg-slate-100 text-slate-700'

export const environmentOf = (environment) => ENVIRONMENTS[environment.kind] || ENVIRONMENTS.none

export const environmentLabel = (environment) => {
  if (environment.kind === 'preview' && environment.pr_number) return `Preview PR #${environment.pr_number}`
  if (environment.kind === 'staging') return 'Staging'
  if (environment.kind === 'preview') return 'Preview'
  return 'Environnement en préparation'
}

export const hostOf = (url) => {
  try { return new URL(url).host } catch (e) { return url }
}

const UNITS = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60]]

export const timeAgo = (value) => {
  const date = value && new Date(value)
  if (!date || isNaN(date)) return ''
  const seconds = (date - Date.now()) / 1000
  const format  = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' })
  const [unit, size] = UNITS.find(([, s]) => Math.abs(seconds) >= s) || ['minute', 60]
  return format.format(Math.round(seconds / size), unit)
}

const fold = (value) => (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export const matchesSearch = (issue, search) => {
  const needle = fold(search).trim()
  if (needle === '') return true
  return fold(`#${issue.number} ${issue.title}`).includes(needle)
}

// Same wording as the controller's, for when GitHub's answer never arrives.
export const REACH_GITHUB  = 'Cliquez sur Actualiser pour charger les informations depuis GitHub.'
export const RETRY_CHECK   = 'Cliquez de nouveau sur la case pour enregistrer ce point sur GitHub.'
export const RETRY_COMMENT = 'Votre commentaire est conservé. Cliquez sur Publier pour l’envoyer de nouveau.'
